import React from 'react';
import Modal from '../../../components/Modal';

const CropDetailsModal = ({ 
  isOpen, 
  onClose, 
  selectedCrop, 
  getCropDetails 
}) => {
  if (!selectedCrop) return null;

  const cropDetails = getCropDetails(selectedCrop);

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title={`${selectedCrop.name}植保建议`}
    >
      <div className="p-6 text-sm">
        <div className="space-y-4">
          <div>
            <h4 className="font-semibold text-base mb-2 text-green-800">基本信息</h4>
            <div className="bg-green-50 p-4 rounded-lg">
              <p><strong>植物名称：</strong>{selectedCrop.name}</p>
              <p><strong>保护措施：</strong>{selectedCrop.plantingTime}</p>
              <p><strong>注意事项：</strong>{selectedCrop.harvestTime}</p>
              <p><strong>建议理由：</strong>{selectedCrop.reason}</p>
            </div>
          </div>
          
          {cropDetails.plantingMethod && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-blue-800">防治方法</h4>
              <div className="bg-blue-50 p-4 rounded-lg">
                {cropDetails.plantingMethod.method && (
                  <p><strong>防治方式：</strong>{cropDetails.plantingMethod.method}</p>
                )}
                {cropDetails.plantingMethod.depth && (
                  <p><strong>防治深度：</strong>{cropDetails.plantingMethod.depth}</p>
                )}
                {cropDetails.plantingMethod.density && (
                  <p><strong>防治密度：</strong>{cropDetails.plantingMethod.density}</p>
                )}
              </div>
            </div>
          )}
          
          {cropDetails.fieldManagement && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-yellow-800">植保管理</h4>
              <div className="bg-yellow-50 p-4 rounded-lg">
                {cropDetails.fieldManagement.irrigation && (
                  <p><strong>环境要求：</strong>{cropDetails.fieldManagement.irrigation}</p>
                )}
                {cropDetails.fieldManagement.fertilization && (
                  <p><strong>营养管理：</strong>{cropDetails.fieldManagement.fertilization}</p>
                )}
                {cropDetails.fieldManagement.pestControl && (
                  <p><strong>病虫害防治：</strong>{cropDetails.fieldManagement.pestControl}</p>
                )}
              </div>
            </div>
          )}
          
          {cropDetails.weatherConsiderations && Array.isArray(cropDetails.weatherConsiderations) && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-purple-800">气象考虑</h4>
              <div className="bg-purple-50 p-4 rounded-lg">
                {cropDetails.weatherConsiderations.map((item, index) => (
                  <p key={index}><strong>注意事项{index + 1}：</strong>{item}</p>
                ))}
              </div>
            </div>
          )}
          
          {cropDetails.soilRecommendations && Array.isArray(cropDetails.soilRecommendations) && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-orange-800">土壤建议</h4>
              <div className="bg-orange-50 p-4 rounded-lg">
                {cropDetails.soilRecommendations.map((item, index) => (
                  <p key={index}><strong>建议{index + 1}：</strong>{item}</p>
                ))}
              </div>
            </div>
          )}
          
          {cropDetails.economicAnalysis && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-green-800">经济分析</h4>
              <div className="bg-green-50 p-4 rounded-lg">
                {cropDetails.economicAnalysis.高价值作物 && Array.isArray(cropDetails.economicAnalysis.高价值作物) && (
                  <p><strong>高价值作物：</strong>{cropDetails.economicAnalysis.高价值作物.join('、')}</p>
                )}
                {cropDetails.economicAnalysis.市场趋势 && (
                  <p><strong>市场趋势：</strong>{cropDetails.economicAnalysis.市场趋势}</p>
                )}
              </div>
            </div>
          )}
          
          {cropDetails.riskWarnings && Array.isArray(cropDetails.riskWarnings) && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-red-800">风险预警</h4>
              <div className="bg-red-50 p-4 rounded-lg">
                {cropDetails.riskWarnings.map((item, index) => (
                  <p key={index}><strong>风险{index + 1}：</strong>{item}</p>
                ))}
              </div>
            </div>
          )}
          
          {cropDetails.expertTips && Array.isArray(cropDetails.expertTips) && (
            <div>
              <h4 className="font-semibold text-base mb-2 text-indigo-800">专家建议</h4>
              <div className="bg-indigo-50 p-4 rounded-lg">
                {cropDetails.expertTips.map((item, index) => (
                  <p key={index}><strong>建议{index + 1}：</strong>{item}</p>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default CropDetailsModal;
